export const amortizationButtonWrapperStyles = { marginTop: '16px' };

export const modalHeadStyles = { display: 'flex', gap: '16px' };
